import React, { useState } from "react";
import { ErrorMessage, Input, Label } from "./styledComponent/formInputs";
import Button from "../common/Button";
import Loading from "./Loading";
import { toast } from "react-toastify";
import { addTag } from "../api/dashboardApi";

const AddTags = ({ setModalIsOpen, setRefresh }) => {
  const [name, setName] = useState("");
  const [inputError, setInputError] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let nameError = "";

    if (!name) {
      nameError = "name is required";
    }

    if (nameError) {
      setInputError((curr) => {
        return {
          name: nameError,
        };
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const checkValidate = validate();
    if (checkValidate) {
      setInputError({});
      setLoading(true);
      try {
        await addTag({ name });

        setLoading(false);
        toast.success("Tag added successfully");
        setName("");
        setModalIsOpen(false);
        setRefresh((curr) => !curr);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  return (
    <div className="addTags">
      <h3>Create A Tag</h3>

      <div className="addTags__form">
        <div className="addBlog__main__form__item">
          <Label htmlFor="name">
            Name <span>*</span>
          </Label>

          <Input
            width="300px"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <ErrorMessage>{inputError?.name}</ErrorMessage>
        </div>

        <div className="addBlog__main__form__btn">
          <Button onClick={handleSubmit}>
            {loading ? <Loading button={true} /> : "Add"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddTags;
